import type { ParamSpec } from "@cfg/design-sdk";

export interface ParamRow {
  name: string;
  label: string;
  value: string;
  unit?: string;
  isDefault: boolean;
}

/** Table rows in the design's own order, with labels and units from its spec; params the spec doesn't know follow by name. */
export function paramRows(spec: ParamSpec[], params: Record<string, unknown>, on: string, off: string): ParamRow[] {
  const fmt = (s: ParamSpec | undefined, v: unknown): string => {
    if (typeof v === "boolean") return v ? on : off;
    if (s?.type === "select") return s.options?.find((o) => o.value === v)?.label ?? String(v);
    if (typeof v === "number") return String(Math.round(v * 1000) / 1000);
    if (v !== null && typeof v === "object") return JSON.stringify(v);
    return String(v ?? "");
  };
  const known = new Set(spec.map((s) => s.name));
  const rows: ParamRow[] = spec
    .filter((s) => s.name in params)
    .map((s) => ({
      name: s.name,
      label: s.label || s.name,
      value: fmt(s, params[s.name]),
      unit: s.type === "number" || s.type === "int" ? s.unit : undefined,
      isDefault: Object.is(params[s.name], s.default),
    }));
  for (const [k, v] of Object.entries(params)) if (!known.has(k)) rows.push({ name: k, label: k, value: fmt(undefined, v), isDefault: false });
  return rows;
}
